import { useState } from 'react'
import { useTranslation } from '../../locales/useTranslation'
import BookingForm from '../bookings/BookingForm'

const DAYS = ['Ma', 'Di', 'Wo', 'Do', 'Vr', 'Za', 'Zo']

// requireAuth works like a middleware function:
// if logged in → runs the action
// if not logged in → shows login screen first, then runs action after
const ChargerDetail = ({ charger, session, onClose, showToast, requireAuth }) => {
  const { t } = useTranslation()
  const [showBooking, setShowBooking] = useState(false)

  const handleBookingSuccess = () => {
    setShowBooking(false)
    showToast(t('boeking_verzonden'))
  }

  const handleBookClick = () => {
    // If not logged in, requireAuth will trigger login first
    // then automatically open the booking form after login
    requireAuth(() => setShowBooking(true))
  }

  return (
    <div style={{
      position: 'absolute', bottom: 0, left: 0, right: 0,
      zIndex: 20, padding: '0 14px 14px',
      animation: 'slideUp 0.3s cubic-bezier(.32,1.2,.5,1)'
    }}>
      <div style={{
        background: 'white', borderRadius: 20, padding: 18,
        border: '1px solid var(--cream-dark)',
        boxShadow: '0 -4px 32px rgba(0,0,0,0.12)'
      }}>

        {/* Header */}
        <div style={{
          display: 'flex', justifyContent: 'space-between',
          alignItems: 'flex-start', marginBottom: 12
        }}>
          <div style={{ flex: 1, marginRight: 10 }}>
            <div style={{
              fontFamily: 'Fraunces, serif', fontSize: 17,
              fontWeight: 900, color: 'var(--ink)', marginBottom: 3
            }}>
              {charger.name}
            </div>
            <div style={{ color: 'var(--ink-muted)', fontSize: 12 }}>
              📍 {charger.address}, {charger.city}
            </div>
          </div>
          <div style={{ display: 'flex', gap: 8, alignItems: 'center', flexShrink: 0 }}>
            <span style={{
              background: charger.is_available ? 'var(--green-pale)' : '#fee2e2',
              color: charger.is_available ? 'var(--green)' : 'var(--red)',
              borderRadius: 20, padding: '3px 10px', fontSize: 11, fontWeight: 800
            }}>
              {charger.is_available ? t('beschikbaar') : t('bezet')}
            </span>
            <button
              onClick={onClose}
              style={{
                background: 'var(--cream)', border: '1px solid var(--cream-dark)',
                color: 'var(--ink-muted)', borderRadius: 8,
                width: 28, height: 28, cursor: 'pointer', fontSize: 16,
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                fontFamily: 'DM Sans, sans-serif'
              }}>
              ×
            </button>
          </div>
        </div>

        {/* Tags */}
        <div style={{ display: 'flex', gap: 7, marginBottom: 12, flexWrap: 'wrap' }}>
          {[
            charger.connector_type,
            `${charger.speed_kw}kW`,
            `€${charger.price_per_kwh}/kWh`
          ].map((v, i) => (
            <span key={i} style={{
              background: 'var(--cream)', border: '1px solid var(--cream-dark)',
              borderRadius: 20, padding: '3px 10px',
              fontSize: 11, color: 'var(--green)', fontWeight: 700
            }}>
              {v}
            </span>
          ))}
        </div>

        {/* Availability */}
        {charger.charger_availability && charger.charger_availability.length > 0 && (
          <div style={{ marginBottom: 12 }}>
            <div style={{
              fontSize: 11, fontWeight: 700, color: 'var(--ink-soft)',
              letterSpacing: 0.5, textTransform: 'uppercase', marginBottom: 6
            }}>
              {t('beschikbaarheid')}
            </div>
            <div style={{ display: 'flex', gap: 4, flexWrap: 'wrap' }}>
              {charger.charger_availability.map((slot, i) => (
                <div key={i} style={{
                  background: 'var(--green-pale)', border: '1px solid var(--green-mid)',
                  borderRadius: 8, padding: '3px 8px',
                  fontSize: 10, color: 'var(--green)', fontWeight: 600
                }}>
                  {DAYS[slot.day_of_week]} {slot.start_time.slice(0, 5)}–{slot.end_time.slice(0, 5)}
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Booking section */}
        {showBooking && session ? (
          <BookingForm
            charger={charger}
            session={session}
            onSuccess={handleBookingSuccess}
            onCancel={() => setShowBooking(false)}
            showToast={showToast}
          />
        ) : (
          charger.is_available ? (
            <button
              onClick={handleBookClick}
              style={{
                width: '100%', background: 'var(--green)',
                border: 'none', borderRadius: 14, padding: '14px',
                color: 'white', fontSize: 15, fontWeight: 700,
                cursor: 'pointer', fontFamily: 'DM Sans, sans-serif'
              }}>
              {session ? `${t('boeken')} →` : '🔐 Inloggen om te boeken →'}
            </button>
          ) : (
            <div style={{
              background: '#fef2f2', border: '1px solid #fecaca',
              borderRadius: 13, padding: 12, textAlign: 'center',
              color: 'var(--red)', fontSize: 13
            }}>
              {t('nu_bezet')}
            </div>
          )
        )}
      </div>
    </div>
  )
}

export default ChargerDetail
